import { TaxFilingStatus } from '../../graphql/schema';

export const formatTaxFilingStatus = (taxFilingStatus: TaxFilingStatus) => {
  switch (taxFilingStatus) {
    case TaxFilingStatus.HeadOfHousehold:
      return 'Head of household';
    case TaxFilingStatus.MarriedFilingJointly:
      return 'Married filing jointly';
    case TaxFilingStatus.QualifyingSurvivingSpouse:
      return 'Qualifying surviving spouse';
    case TaxFilingStatus.MarriedFilingSeparately:
      return 'Married filing separately';
    case TaxFilingStatus.MarriedFilingSeparatelyLivingApart:
      return 'Married filing separately (living apart)';
    case TaxFilingStatus.Single:
      return 'Single';
    default:
      return '-';
  }
};
